import React, {useEffect, useRef, useState} from "react";
import "./style.less";
import {
    Button,
    ButtonGroup,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Glyphicon,
    MenuItem,
    SplitButton
} from "react-bootstrap";
import CertificateEditor from "../../../../certificateEditor";
import {clientCertificateSendMail, clientCertificateUpdate} from "api";
import {useEventContext} from "../../../../context";

const FONT_FAMILIES = ['Helvetica', 'Helvetica Neue', 'Tahoma', 'Sans Serif', 'Arial', 'Courier New'];
const FONT_SIZES = [6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 72, 80, 84, 86, 96, 120];

export default () => {
    const {event} = useEventContext();
    const canvasRef = useRef(null);
    const fontFamilyRef = useRef(null);
    const fontSizeRef = useRef(null);

    const [editor, setEditor] = useState(null);
    const [tool, setTool] = useState(null);
    const [fontSize, setFontSize] = useState(12);
    const [fontFamily, setFontFamily] = useState('Helvetica');
    const [textAlign, setTextAlign] = useState('left');
    const [textColor, setTextColor] = useState('#000000');
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);

    useEffect(() => {
        const editor = new CertificateEditor('canvas', {width: 700, height: 1000});
        editor.setEvent(event);
        editor.onToolChange = (tool) => setTool(tool);
        editor.onSelectionChange = (activeObjects) => {
            if (0 === activeObjects.length) {
                return;
            }

            let object = activeObjects[0];
            let fontSize = object.fontSize;
            let fontFamily = object.fontFamily;
            let textAlign = object.textAlign;
            let isBold = object.fontWeight === 'bold';
            let isItalic = object.fontStyle === 'italic';
            let textColor = object.fill;

            setFontSize(fontSize);
            setFontFamily(fontFamily);
            setTextAlign(textAlign);
            setIsBold(isBold);
            setIsItalic(isItalic);
            setTextColor(textColor);

            if (activeObjects.length > 1) {
                for (let i = 1; i < activeObjects.length; i++) {
                    if (fontSize !== activeObjects[i].fontSize) {
                        fontSizeRef.current.selectedIndex = -1;
                    }

                    if (fontFamily !== activeObjects[i].fontFamily) {
                        fontFamilyRef.current.selectedIndex = -1;
                    }
                }
            }
        };
        editor.onPropertyChange = (property, value) => {
            switch (property) {
                case 'fontSize':
                    setFontSize(value);
                    break;
                case 'fontFamily':
                    setFontFamily(value);
                    break;
                case 'textAlign':
                    setTextAlign(value);
                    break;
                case 'textColor':
                    setTextColor(value);
                    break;
                case 'isBold':
                    setIsBold(value);
                    break;
                case 'isItalic':
                    setIsItalic(value);
                    break;
            }
        };

        setEditor(editor);
    }, []);

    const backgroundUpload = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);

        clientCertificateUpdate(event.eventPassword, formData)
            .then(data => editor.setBackgroundImageFromUrl(data.url))
            .catch(() => {})
        ;
    }

    const handleMailBroadcast = () => {
        const confirmText = 'Всем зарегистрированным зретелям будут отпрвленны письма с сертификатом';
        if (!confirm(confirmText)) {
            return;
        }
        clientCertificateSendMail(event.eventPassword)
            .then(() => alert('Письма будут разосланы в ближайшее время'))
            .catch(() => alert('При отправке писем произошла ошибка'))
        ;
    }

    const handleCreateInput = (eventKey, e) => {
        if (undefined === e) {
            e = eventKey;
            editor.setTool('text');
        } else {
            editor.setTool('text:{' + eventKey + '}');
        }

        e.stopPropagation();
    }

    let fields = event.registrationFields
        .filter(({field}) => -1 === ['checkbox', 'radio'].indexOf(field.type))
        .map(({field}) => ({value: field.name, label: field.label_ru}));
    fields.unshift({value: 'name', label: 'Имя'});
    if (event.moduleAuth.email) {
        fields.unshift({value: 'email', label: 'eMail'});
    }

    return (
        <div style={{paddingTop: '30px'}}>
            <div className="controls-wrapper">
                <div className="controls-group tools">
                    <SplitButton
                        title={'Добавить поле'}
                        id="create-certificate-field"
                        onClick={handleCreateInput}
                        onSelect={handleCreateInput}
                        bsSize="small"
                        bsStyle={(tool || '').split(':')[0] === 'text' ? 'primary' : 'default'}
                    >
                        {fields.map(({value, label}) => (
                            <MenuItem eventKey={value} key={value}>{`${label} \`{${value}}\``}</MenuItem>
                        ))}
                    </SplitButton>

                    <Button bsSize="small" onClick={() => editor.deleteActiveObjects()}>
                        <Glyphicon glyph="trash"/>
                    </Button>
                </div>
                <div className="controls-group">
                        <FormControl
                            bsSize="small"
                            componentClass="select"
                            ref={fontFamilyRef} value={fontFamily} onChange={e => editor.handlePropertyChange('fontFamily', e.target.value)}
                            className={"font-family-select"}
                        >
                            {FONT_FAMILIES.map(fontFamily => <option key={fontFamily} value={fontFamily}>{fontFamily}</option>)}
                        </FormControl>
                        <FormControl
                            bsSize="small"
                            componentClass="select"
                            ref={fontSizeRef}
                            value={fontSize}
                            onChange={e => editor.handlePropertyChange('fontSize', parseInt(e.target.value))}
                            className={"font-size-select"}
                        >
                            {FONT_SIZES.map(fontSize => <option key={fontSize} value={fontSize}>{fontSize}px</option>)}
                        </FormControl>
                    <ButtonGroup>
                        <Button bsSize="small" bsStyle={isBold ? 'primary' : 'default'} onClick={() => editor.handlePropertyChange('isBold', !isBold)}>
                            <Glyphicon glyph="bold"/>
                        </Button>
                        <Button bsSize="small" bsStyle={isItalic ? 'primary' : 'default'} onClick={() => editor.handlePropertyChange('isItalic', !isItalic)}>
                            <Glyphicon glyph="italic"/>
                        </Button>
                    </ButtonGroup>
                    <ButtonGroup>
                        <Button bsSize="small" bsStyle={textAlign === 'left' ? 'primary': 'default'} onClick={() => editor.handlePropertyChange('textAlign', 'left')}>
                            <Glyphicon glyph="align-left"/>
                        </Button>
                        <Button bsSize="small" bsStyle={textAlign === 'center' ? 'primary': 'default'} onClick={() => editor.handlePropertyChange('textAlign', 'center')}>
                            <Glyphicon glyph="align-center"/>
                        </Button>
                        <Button bsSize="small" bsStyle={textAlign === 'right' ? 'primary': 'default'} onClick={() => editor.handlePropertyChange('textAlign', 'right')}>
                            <Glyphicon glyph="align-right"/>
                        </Button>
                        <Button bsSize="small" bsStyle={textAlign === 'justify' ? 'primary': 'default'} onClick={() => editor.handlePropertyChange('textAlign', 'justify')}>
                            <Glyphicon glyph="align-justify"/>
                        </Button>
                    </ButtonGroup>
                    <FormControl
                        bsSize="small"
                        type="color"
                        value={textColor}
                        onChange={e => editor.handlePropertyChange('textColor', e.target.value)}
                    />
                </div>
                <div className="controls-group" style={{ marginLeft: 'auto', marginRight: '16px', borderRight: 'none' }}>
                    <Button onClick={handleMailBroadcast}>Отправить письма зрителям</Button>
                </div>
            </div>
            <Form style={{display: 'inline-block'}}>
                <FormGroup>
                    <ControlLabel>Изображение сертификата</ControlLabel>
                    <FormControl type="file" onChange={backgroundUpload}/>
                </FormGroup>
            </Form>
            <div
                className="canvas-wrap"
            >
                <canvas
                    ref={canvasRef}
                    id="canvas"
                />
            </div>
        </div>
    );
}
